import React from 'react'
import config from '../../config'
import {
  LinkIcon
} from '../../components'


// {
//   MenuConfig.map((col, colI) => {
//     return <Col xs={12} sm={12} md={3} lg={3}
//       key={'menu-col-'+colI}
//       styleName='menu-column'
//     >
//       {
//         col.map((item, itemI)=>{
//           return <div
//             key={'menu-item-'+itemI}
//             styleName={'menu-link-'+item[2]}
//           >
//             <Link
//               to={item[0]}
//               title={item[1]}
//             >
//               {
//                 item[3] ?
//                   <span>
//                     <LinkIcon
//                       nospace
//                       faclass={'fa-'+item[3]}
//                     />
//                     &nbsp;
//                   </span> :
//                   null
//               }{item[1]}
//               {
//                 item[4] ?
//                   <span styleName='menu-subtitle'>
//                     {item[4]}
//                   </span> :
//                   null
//               }
//             </Link>
//           </div>
//         })
//       }

const MenuConfig = [
  [
    [
      config.routes.home,
      'Home',
      'l'
    ],
    [
      config.routes.about,
      'About us',
      'l'
    ],
    [
      config.routes.howitworks,
      'How it works',
      's'
    ],
    [
      config.routes.videoTutorials,
      'Video tutorials',
      's'
    ],
    [
      config.routes.resources,
      'Resources',
      's'
    ],
    [
      config.routes.fossilFuelCompanies,
      'Fossil fuel companies',
      'l'
    ],
    [
      config.routes.carbonunderground200,
      'Carbon reserve owners',
      's',
      null,
      'Carbon Underground 200™'
    ],
    [
      config.routes.macroclimate50,
      'Coal-fired utilities',
      's',
      null,
      'Macroclimate® 50'
    ],
    // [
    //   config.routes.morningstar,
    //   'Morningstar®',
    //   's',
    //   null,
    //   'Fossil fuel industries'
    // ],
    [
      config.routes.banksInsurance,
      'Fossil fuel finance & insurance',
      's',
    ],
    [
      config.routes.clean200,
      'Clean200™',
      's',
    ],
    // [
    //   config.routes.carbonfootprint,
    //   'Carbon footprint',
    //   's',
    //   null,
    //   (<span >Portfolio emissions<LinkIcon faclass='fa-exclamation-triangle' /></span>)
    // ]
  ],
  [
    [
      config.routes.clean,
      'Search funds',
      'l',
      'search'
    ],
    // [
    //   config.routes.indexfunds,
    //   'Index funds',
    //   's'
    // ],
    // [
    //   config.routes.targetdate,
    //   'Target date funds',
    //   's'
    // ],
    // [
    //   config.routes.families,
    //   'Fund managers',
    //   'l'
    // ],
    // [
    //   config.routes.families+'?q=Vanguard',
    //   'Vanguard',
    //   's'
    // ],
    // [
    //   config.routes.families+'?q=BlackRock%2FiShares',
    //   'BlackRock/iShares',
    //   's'
    // ],
    // [
    //   config.routes.families+'?q=State%20Street',
    //   'State Street',
    //   's'
    // ],
    // [
    //   config.routes.tspLanding,
    //   'Thrift Savings Plan',
    //   's'
    // ],
    // [
    //   config.routes.families,
    //   'More fund managers',
    //   's'
    // ],
  ],
  [
    [
      config.links.blog,
      'Insights',
      'l'
    ],
    [
      config.routes.toolkit,
      'Fossil free action toolkit',
      'l'
    ],
    [
      config.links.signup,
      'Sign up',
      'l',
      'envelope-o'
    ],
    [
      config.links.donate,
      'Donate to As You Sow',
      'l',
      'heart'
    ],
    [
      config.routes.media,
      'Media',
      's'
    ],
    [
      config.links.contact,
      'Contact us',
      's'
    ],
    [
      config.routes.legal,
      'Legal disclaimer',
      's'
    ]
  ]
]

export default MenuConfig